import { type TierName } from "@/types/tiers.types";
import { getTierConfig } from "@/config/tiers";

interface TierSectionHeaderProps {
  tierName: TierName;
  isUnlocked: boolean;
  taskCount: number;
  completedTaskCount?: number;
}

export const TierSectionHeader = ({
  tierName,
  isUnlocked,
  taskCount,
  completedTaskCount,
}: TierSectionHeaderProps) => {
  const tierConfig = getTierConfig(tierName);

  return (
    <div className="mb-6 mt-8 first:mt-0">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-swapper-secondary">
          {tierConfig.displayName}
        </h2>
        {isUnlocked && completedTaskCount !== undefined && (
          <span className="text-sm text-gray-500">
            {completedTaskCount} / {taskCount} completed
          </span>
        )}
      </div>
    </div>
  );
};
